import { Stack } from "@mui/material";
import { ListingModal } from "../listingModal/ListingModal";
import { ListingModalProvider } from "../listingModal/ListingModalProvider";

export const ListingDetailsModalSection = () => {
  return (
    <Stack className="relative -translate-x-1/2 transform left-1/2 lg:hidden">
      <ListingModalProvider>
        <ListingModal />
      </ListingModalProvider>
    </Stack>
  );
};
